import React, { useMemo, useState, useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { addWorkflowTarefaMembro } from "../../store/workflow";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import ActionLink from "../action-link";
import PropTypes from "prop-types";
import styles from "./_WorkflowTarefaModal.less";
import useCollator from "../../hooks/useCollator";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import axios from "axios";

export default function WorkflowTarefaMembroAtalho({ tarefaId, membros = [], workflowId, onUpdate }) {
  const { t } = useTranslation();
  const { compare, contains } = useCollator();
  const dispatch = useDispatchWithResult();
  const [exibeBotao, setExibeBotao] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [AllMembros, setAllMembros] = useState([]);

  useEffect(() => {
    let isMounted = true;
    unwrapAxiosPromise(axios.get(`/workflows/${workflowId}/membros`)).then((lista) => {
      if (isMounted) {
        setAllMembros(lista);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [workflowId]);

  const membrosFiltrados = useMemo(() => {
    return AllMembros.filter((m) => !membros.some((membro) => membro.id === m.id))
      .filter((m) => contains(m.nome, searchValue))
      .sort((a, b) => compare(a.nome, b.nome))
      .slice(0, 50);
  }, [AllMembros, membros, searchValue, contains, compare]);

  const handleClick = () => {
    setExibeBotao(false);
  };

  const handleBlur = () => {
    setExibeBotao(true);
  };

  const handleChange = (membroId) => {
    unwrapAxiosPromise(
      dispatch(
        addWorkflowTarefaMembro({
          workflowId,
          id: tarefaId,
          membroId,
          refetch: false,
        })
      )
    ).then(() => {
      if (onUpdate) {
        onUpdate();
      }
      setExibeBotao(true);
    });
  };

  if (exibeBotao) {
    return <ActionLink.Create title={t("Adicionar Membro")} onClick={handleClick} />;
  }

  return (
    <div className={styles["membro-adicionar"]}>
      <Select autoFocus filterOption={false} onBlur={handleBlur} onChange={handleChange} onSearch={setSearchValue} searchValue={searchValue} showSearch>
        {membrosFiltrados.map((membro) => (
          <Select.Option key={membro.id} value={membro.id}>
            {membro.nome}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}

WorkflowTarefaMembroAtalho.propTypes = {
  tarefaId: PropTypes.number.isRequired,
  tarefa: PropTypes.shape({
    membros: PropTypes.arrayOf(PropTypes.number).isRequired,
  }).isRequired,
  workflow: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  membroByIdMap: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      nome: PropTypes.string.isRequired,
    })
  ).isRequired,
};
